import I18n from 'I18n';
import { List } from 'immutable';
import { useCallback } from 'react';
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { HELPDESK } from '../../shared/constants/workspaces';
import { useTeamOptions } from '../../team/hooks/useTeamOptions';
import { TrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import AgentSelectItem from '../../users-and-teams/components/AgentSelectItem';
import { RoutableUsersAndTeamsSelect } from '../../users-and-teams/components/RoutableUsersAndTeamsSelect';
import { useConvertToTeamOnlyOptions } from '../../users-and-teams/hooks/useConvertToTeamOnlyOptions';
import { useSelectedUsersAndTeams } from '../../users-and-teams/hooks/useSelectedUsersAndTeams';
import { useShowFooter } from '../hooks/useShowFooter';
import { getTeamsOnly } from '../operators/routingRulesGetters';
import { ensureChildTeamsAppearSelected } from '../../users-and-teams/utils/select-teams';
import ManageSeatsBanner from './ManageSeatsBanner';
import { convertListToArray } from '../../shared/utils/immutable';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
const TeamsOnlyRow = ({
  routingRules,
  disabled,
  inboxId,
  isUngatedForHelpDeskRoutingScopeFiltering,
  objectTypeId,
  onTeamSelect = noop,
  routingSource,
  teamsSelectError,
  trackUsage = noop,
  workSpace
}) => {
  const {
    showFooter,
    dismissFooter
  } = useShowFooter();
  const teamIds = getTeamsOnly(routingRules);
  const isNewSeatingModel = isUngatedForHelpDeskRoutingScopeFiltering && (workSpace === HELPDESK || routingSource === ROUTING_SOURCE.HELP_DESK);
  const errorMessage = teamsSelectError ? I18n.text('routing-ui.routingRules.roundRobin.selectTeam') : undefined;
  const ItemComponent = useCallback(props => /*#__PURE__*/_jsx(AgentSelectItem, Object.assign({
    isNewSeatingModel: isNewSeatingModel,
    isOptionItemInDropdown: true
  }, props)), [isNewSeatingModel]);
  const {
    loading,
    teams: teamOptions,
    data: teams
  } = useTeamOptions({
    convertToOptions: useConvertToTeamOnlyOptions(routingSource),
    objectTypeId,
    routingSource,
    workspaceId: Number(inboxId)
  });
  const {
    normalizeTeams,
    selectedIds: displayedTeamIds
  } = useSelectedUsersAndTeams({
    teamIds: convertListToArray(teamIds),
    teams
  });
  const handleChange = useCallback((_userIds, newTeamIds) => {
    const normalizedTeamIds = normalizeTeams(newTeamIds);
    onTeamSelect(List(ensureChildTeamsAppearSelected(normalizedTeamIds, teams)));
  }, [normalizeTeams, onTeamSelect, teams]);
  return /*#__PURE__*/_jsx(TrackUsageContext.Provider, {
    value: trackUsage,
    children: /*#__PURE__*/_jsx(RoutableUsersAndTeamsSelect, {
      "data-test-id": "teams-only-row-select",
      disabled: !!disabled,
      footer: showFooter && isNewSeatingModel ? /*#__PURE__*/_jsx(ManageSeatsBanner, {
        isTeamsOnlyLink: true,
        onClose: dismissFooter
      }) : null,
      error: errorMessage,
      loading: loading,
      onChange: handleChange,
      itemComponent: ItemComponent,
      placeholder: I18n.text('routing-ui.users-and-teams.select.placeholder-team-only'),
      selected: displayedTeamIds,
      teams: teamOptions,
      valueComponent: AgentSelectItem
    })
  });
};
TeamsOnlyRow.displayName = 'TeamsOnlyRow';
export default TeamsOnlyRow;